module.exports = __webpack_public_path__ + "static/media/LOGO-CRHONOS-REGISTRO.3e8ca94b.png";